import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { toast } from "sonner";
import { http, apiError } from "@/lib/api";
import { useSite } from "@/context/SiteContext";
import Field from "@/admin/Field";

const FIELDS = [
  { key: "announcement", label: "Aviso no topo da homepage (vazio = sem aviso)", type: "text" },
  { key: "hero_image", label: "Imagem principal (hero)", type: "image" },
  { key: "hero_video", label: "Vídeo principal (URL MP4, opcional)", type: "text" },
  { key: "map_image", label: "Planta oficial do recinto (substitui o mapa demonstrativo)", type: "image" },
  { key: "support_banner", label: "Imagem de logótipos: Organização e apoios", type: "image" },
  { key: "partners_banner", label: "Imagem de logótipos: Parceiros", type: "image" },
  { key: "website", label: "Website oficial (URL)", type: "text" },
  { key: "contact_email", label: "Email de contacto", type: "text" },
  { key: "contact_phone", label: "Telefone de contacto", type: "text" },
  { key: "instagram", label: "Instagram (URL)", type: "text" },
  { key: "facebook", label: "Facebook (URL)", type: "text" },
  { key: "youtube", label: "YouTube (URL)", type: "text" },
  { key: "linkedin", label: "LinkedIn (URL)", type: "text" },
  { key: "now_override", label: "Simular data/hora de “Agora na Feira” (vazio = hora real de Lisboa)", type: "datetime" },
];

export default function AdminSettings() {
  const { isAdmin } = useOutletContext();
  const site = useSite();
  const [form, setForm] = useState(null);
  useEffect(() => { http.get("/admin/settings").then((r) => setForm(r.data)).catch((e) => toast.error(apiError(e))); }, []);
  if (!form) return <p role="status">A carregar…</p>;
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const save = async (e) => {
    e.preventDefault();
    try { await http.put("/admin/settings", form); toast.success("Definições guardadas"); site.reload(); } catch (err) { toast.error(apiError(err)); }
  };
  return (
    <form onSubmit={save} className="max-w-2xl space-y-4" data-testid="admin-settings-form">
      <h1 className="font-display text-3xl font-extrabold">Definições do site</h1>
      {!isAdmin && <p className="rounded-xl bg-amber-100 p-3 text-sm text-amber-900">Apenas administradores podem alterar as definições.</p>}
      {FIELDS.map((f) => <Field key={f.key} f={f} form={form} set={set} refs={{}} isAdmin={isAdmin} />)}
      {isAdmin && <button className="h-12 px-6 rounded-full bg-[var(--leaf)] text-white font-bold" data-testid="admin-settings-save">Guardar definições</button>}
    </form>
  );
}
